import {
  FETCH_MENU_ITEMS,
  FETCHING
} from '../actions/layoutActions'

const initialStore = {
  isFetching: false,
  error: null,
  data: null
}

export default (state = initialStore, action) => {
  switch (action.type) {
    case FETCH_MENU_ITEMS: {
      return {
        data: {
          ...state.data,
          menuItems: action.payload
        },
        isFetching: false
      }
    }

    case FETCHING: {
      return {
        ...state,
        isFetching: action.payload
      }
    }


    default: {
      return state
    }
  }
}
